<div class="header">
  <div class="header__section">
    <div class="header__section-icon">
      <ion-img src="assets/img/localization.svg"></ion-img>
    </div>
    <div (click)="openLanguageModal()" class="header__section-text header__language">
      {{ currentLanguage?.languageDisplayLocale }}
    </div>
  </div>
  <div class="header__section" (click)="logoutUser()">
    <div class="header__section-icon">
      <ion-img src="assets/img/logout-icon.svg"></ion-img>
    </div>
    <div class="header__section-text">Sign Out</div>
  </div>
</div>
